/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Approveprospectlist_Description3Inputs */

const en_coinvestments_approveprospectlist_description3 = /** @type {(inputs: Coinvestments_Approveprospectlist_Description3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`These prospects will now be available to start the outreach phase`)
};

/**
* | output |
* | --- |
* | "These prospects will now be available to start the outreach phase" |
*
* @param {Coinvestments_Approveprospectlist_Description3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_approveprospectlist_description3 = /** @type {((inputs?: Coinvestments_Approveprospectlist_Description3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Approveprospectlist_Description3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_approveprospectlist_description3(inputs)
});
export { coinvestments_approveprospectlist_description3 as "coInvestments_approveProspectList_description" }